"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var SwitchTheme = function SwitchTheme(colors) {
  return {
    defaultProps: {
      color: 'default'
    },
    styleOverrides: {
      root: {
        boxSizing: 'border-box',
        width: 40,
        height: 24,
        padding: 0,
        backgroundColor: colors.white
      },
      switchBase: {
        padding: '2px',
        color: colors.white,
        '&.Mui-checked': {
          transform: 'translateX(16px)',
          color: colors.white,
          '& + .MuiSwitch-track': {
            opacity: 1,
            backgroundColor: colors.userBlue,
            borderColor: colors.userBlue
          }
        },
        '&.Mui-disabled': {
          color: colors.white,
          '& + .MuiSwitch-track': {
            opacity: 1,
            backgroundColor: colors.grey30,
            borderColor: colors.grey30
          }
        }
      },
      thumb: {
        width: '20px',
        height: '20px',
        boxShadow: 'none'
      },
      track: {
        width: '40px',
        height: '24px',
        border: "0px solid ".concat(colors.lynch),
        borderRadius: '30px 30px 30px 30px',
        opacity: 1,
        backgroundColor: colors.lynch
      }
    }
  };
};

var _default = SwitchTheme;
exports["default"] = _default;